module.exports = __webpack_public_path__ + "static/portfolio-tamparealtyservice-5097729783384413daa8b11957911de0.jpg";